// @ts-nocheck
import React, { createContext, useContext, ReactNode } from 'react';

const PageKeyContext = createContext<string | undefined>(undefined);

export const PageKeyProvider = ({
  pageKey,
  children,
}: {
  pageKey: string;
  children: ReactNode;
}) => {
  return <PageKeyContext.Provider value={pageKey}>{children}</PageKeyContext.Provider>;
};

export const usePageKey = () => {
  const context = useContext(PageKeyContext);
  if (!context) {
    throw new Error('usePageKey must be used within a PageKeyProvider');
  }
  return context;
};
